module.exports = __webpack_public_path__ + "assets/media/victory.0b31c057.mp3";